import { LocationDTO } from '@sales-center/common'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MappedServiceLocattionUpdateResult } from '@user/components/Location/SelectLocations/reducer/typings'
import { getEmailAddresses } from '@user/store/entityLocations'
import { StoreData } from '../../reducers/typings'
import { State } from './typings'

export const initialState: State = {
  billTo: {
    id: -1,
    billingLocation: true,
    contactId: -1,
    salesTeamId: -1,
    branchId: null,
    branch: null,
    locationType: null,
    locationTypeId: null,
    divisionId: null,
    division: null,
    firstName: null,
    lastName: null,
    title: null,
    company: null,
    emailAddresses: [],
    phoneNumber: null,
    phoneExt: null,
    altPhoneNumber: null,
    altPhoneExt: null,
    street1: null,
    street2: null,
    city: null,
    stateAbbreviation: null,
    postalCode: null,
    county: null,
    country: null,
    longitude: null,
    latitude: null,
    externalLinkId: null,
    externalLinkType: null,
    locationCode: null,
    taxCode: null,
    mobilePhone: null,
    draftAgreementsUpdated: false,
  },
  serviceLocations: [],
  location: undefined,
}

export const addOpportunity = createSlice({
  name: 'addOpportunity',
  initialState,
  reducers: {
    setAddOppBillTo: (state, { payload }: PayloadAction<LocationDTO>) => {
      state.billTo = { ...payload }
      state.billTo.billingLocation = true
    },
    setAddOppResetBool: (state, {}: PayloadAction) => {
      state.location = undefined
    },
    setAddOppLocations: (state, { payload }: PayloadAction<LocationDTO[]>) => {
      state.serviceLocations = payload.map((x) => {
        const { externalLinkId, id, ...rest } = x

        return {
          id: id === -1 ? (externalLinkId != null ? +externalLinkId : -1) : id,
          externalLinkId: externalLinkId,
          ...rest,
        }
      })
    },
    upsertAddOppBillTo: (
      state,
      { payload }: PayloadAction<MappedServiceLocattionUpdateResult>,
    ) => {
      state.billTo.firstName = payload.firstName
      state.billTo.lastName = payload.lastName
      state.billTo.altPhoneNumber = payload.altPhone
      state.billTo.altPhoneExt = payload.altPhoneExt
      state.billTo.company = payload.company
      state.billTo.emailAddresses = payload.email
        ? getEmailAddresses(payload.email)
        : []
      state.billTo.phoneNumber = payload.phone
      state.billTo.phoneExt = payload.phoneExt
      state.location = payload
    },
    upsertAddOppLocation: (
      state,
      { payload }: PayloadAction<MappedServiceLocattionUpdateResult>,
    ) => {
      const { id } = payload
      // no changing the primary

      const location = state.serviceLocations.find(
        (x) => x.externalLinkId == id.toString() || (x.id != -1 && x.id == id),
      )

      if (location) {
        location.firstName = payload.firstName
        location.lastName = payload.lastName
        location.altPhoneNumber = payload.altPhone
        location.altPhoneExt = payload.altPhoneExt
        location.company = payload.company
        location.emailAddresses = payload.email
          ? getEmailAddresses(payload.email)
          : []
        location.phoneNumber = payload.phone
        location.phoneExt = payload.phoneExt

        const locationIndex = state.serviceLocations.findIndex(
          (x) => x.id == id,
        )
        if (locationIndex !== -1) {
          state.serviceLocations[locationIndex] = {
            ...location,
          }
        }
        if (payload.updateBillingLocation) {
          state.billTo.firstName = payload.firstName
          state.billTo.lastName = payload.lastName
          state.billTo.altPhoneNumber = payload.altPhone
          state.billTo.altPhoneExt = payload.altPhoneExt
          state.billTo.company = payload.company
          state.billTo.emailAddresses = payload.email
            ? getEmailAddresses(payload.email)
            : []
          state.billTo.phoneNumber = payload.phone
          state.billTo.phoneExt = payload.phoneExt
        }
        state.location = payload
      }
    },
  },
  extraReducers: () => {},
})

export default addOpportunity.reducer
export const {
  setAddOppBillTo,
  setAddOppLocations,
  upsertAddOppBillTo,
  upsertAddOppLocation,
  setAddOppResetBool,
} = addOpportunity.actions

export const selectAddOpportunitySlice = (state: StoreData) =>
  state.opportunityAddState
